import { RootState } from '€slices/types';
import { ApplicationStages, Commission } from '../../types';

export const getCommission = (state: RootState): Commission => state.stats.commission;

export const getStageStats = (state: RootState): ApplicationStages => state.stats.stages;
